import { ChangeDetectionStrategy, Component, AfterViewInit, Input, ViewChild, ElementRef, HostBinding, HostListener } from '@angular/core';
import { PopoverImproved } from 'components/popover-host/popover-host';
import { CfPopoverBase } from 'components/popover-host/popover-interface';
import { PopoverController } from 'providers/popover-controller';

@Component({
    selector: 'zoom-image-popover',
    templateUrl: 'zoom-image-popover.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ZoomImagePopover extends CfPopoverBase implements AfterViewInit {
  @Input() imageSrc: string;
  /** fullscreen variant (scanner photo inspection): the image area covers
   *  the whole viewport and drops the white letterbox background */
  @Input() @HostBinding('class.fullscreen') fullscreen = false;
  @ViewChild('image') image: ElementRef;
  @ViewChild('imageHolder') imageHolder: ElementRef;
  animationFinished = false;

  popover: PopoverImproved;


  constructor(
    private popoverCtrl: PopoverController,
    private elementRef: ElementRef,
  ) {
    super();
  }

  onWillDismiss(data) {
    void data;
  }

  ngOnInit() {

  }

  // reapply the layout when the window is resized
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    void event;
    this.calculateZoomIconPosition();
  }

  calculateZoomIconPosition() {

    let imageEl = this.image.nativeElement as HTMLImageElement;
    let imageHolderEl = this.imageHolder.nativeElement as HTMLElement;
    let elem = this.elementRef.nativeElement as HTMLElement;
    let imageElRect = imageEl.getBoundingClientRect();
    let imageHolderElRect = imageHolderEl.getBoundingClientRect();
    elem.style.setProperty('--zoom-icon-offset-x', `${imageHolderElRect.right - imageElRect.right}px`);
    elem.style.setProperty('--zoom-icon-offset-y', `${imageElRect.top - imageHolderElRect.top}px`);
  }

  async ngAfterViewInit() {
    // This is little bit scary, but not sure how else I can get it, so we assume last added popover is this one.
    this.popover = this.popoverCtrl.popoverHost.popovers[this.popoverCtrl.popoverHost.popovers.length - 1];

    if (this.popover.animation) {
      await this.popover.animation.finished;
    }

    this.calculateZoomIconPosition();

    this.animationFinished = true;

  }

  onClick() {
    void this.popoverCtrl.dismiss(this);
  }
}